











































import { Component } from "vue-property-decorator";

import {
  DialogSection,
  DialogForm,
  FormText,
  ColorInputField
} from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IQrCodeGeneratorConfiguration } from "sitewhere-configuration-model";
import { required } from "vuelidate/lib/validators";

@Component({
  components: { DialogForm, FormText, VFlex, ColorInputField },
  validations: {
    width: {
      required
    },
    height: {
      required
    },
    foregroundColor: {
      required
    },
    backgroundColor: {
      required
    }
  }
})
export default class QrCodeGeneratorFields extends DialogSection {
  width = 200;
  height = 200;
  foregroundColor = "333333FF";
  backgroundColor = "FFFFFFFF";

  /** Reset section content */
  reset(): void {
    this.width = 200;
    this.height = 200;
    this.foregroundColor = "333333FF";
    this.backgroundColor = "FFFFFFFF";
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IQrCodeGeneratorConfiguration): void {
    this.width = input.width || 200;
    this.height = input.height || 200;
    this.foregroundColor = input.foregroundColor || "#333333FF";
    this.backgroundColor = input.backgroundColor || "#FFFFFFFF";
  }

  /** Save form data to an object */
  save(): {} {
    return {
      width: this.width,
      height: this.height,
      foregroundColor: this.foregroundColor,
      backgroundColor: this.backgroundColor
    };
  }
}
